import React, { ReactNode } from "react";
import PropTypes from "prop-types";
import { Loader } from "../../../components/Loader";
import { Wrapper } from "../../../styled";
import ScrollToTop from "../../../components/scrollToTop";
import Toast from "../../../components/Toast";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";

interface Props {
  children: ReactNode;
}

export default function AdminLayout({ children }: Props) {
  return (
    <Wrapper className="d-flex flex-column">
      <Header />
      <ScrollToTop />
      <Toast />
      <main className="d-flex flex-column flex-grow-1" id="maincontent">
        {children}
      </main>
      <Loader />
      <Footer />
    </Wrapper>
  );
}
AdminLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
